import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(loadSaga),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doPostCtaClick),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSaga);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { fork, call, select, put, takeEvery, all } from 'redux-saga/effects';
import { msas } from 'redux/saga/entities/bound';
import { useSellHeader, toggleFlag } from 'redux/modules/page';
import { flagSelector } from 'redux/saga/selectors/page';
export var ctaClick = function ctaClick(promoAlias) {
  return {
    type: 'HERO_CTA_CLICK',
    promoAlias: promoAlias
  };
};
export function loadSaga(client) {
  return regeneratorRuntime.wrap(function loadSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([put(useSellHeader()), call(fetchEntityIfNeeded, msas, [client])]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doPostCtaClick() {
  var flags;
  return regeneratorRuntime.wrap(function doPostCtaClick$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(flagSelector);

        case 2:
          flags = _context2.sent;

          if (!flags.headerDropdownOpen) {
            _context2.next = 6;
            break;
          }

          _context2.next = 6;
          return put(toggleFlag('headerDropdownOpen'));

        case 6:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
export function watchSaga(client) {
  return regeneratorRuntime.wrap(function watchSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, ctaClick().type, doPostCtaClick, client);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}